import React, {useContext, useEffect, useState} from 'react'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {useLocation} from 'react-router'
import TitleBar from '../../components/TitleBar'
import TabBar from '../../components/TabBar'
import Tab from '../../components/Tab'
import useGet from '../../hooks/useGet'
import usePost from '../../hooks/usePost'
import usePrevious from '../../hooks/usePrevious'

import PortalSalesDetails from '../../components/portal/PortalSalesDetails'
import PortalOpsDetails from '../../components/portal/PortalOpsDetails'
import PortalDetailsHeader from '../../components/portal/PortalDetailsHeader'
import PortalFinanceDetails from '../../components/portal/PortalFinanceDetails'

const PortalDealDetails = ({view, theDealId}) => {
    const {search} = useLocation()
    const params = useParams()
    const queryParams = new URLSearchParams(search)
    const [dealId, setDealId] = useState(params.dealId)
    const selectedView = params.view
    const prevView = usePrevious(params.view)


    const [detailsTab, setDetailsTab] = useState('sales')
    

    const [dealDetails, setDealDetails] = useState(null)
    const [dealDataUrl, setDealDataUrl] = useState(null)
    const [legDataUrl, setLegDataUrl] = useState(null)

    const {loading: dealDataLoading, returnData: dealData} = useGet(dealDataUrl)
    const {loading: legDataLoading, returnData: legData} = useGet(legDataUrl)

    const [actualLegData, setActualLegData] = useState([])
    const {sending, returnMessage, postData} = usePost()    

    if(window.location.state === null) {
        setDealDetails(window.location.state.deal)
    } else {
        //setDealDataUrl(`/api/portal/GetDealByZohoId?dealId=${dealId}`)
        
    }

    useEffect(() => {
        setDealDataUrl(`/api/portal/deal-by-zohoid?dealId=${dealId}`)
    }, [dealData, dealDataUrl, dealId])

    useEffect(() => {
        setLegDataUrl(`/api/portal/legDetails?dealId=${dealId}`)

        if(legData) {
            setActualLegData(legData)
        }
    }, [legData, legDataUrl, dealId])

    useEffect(() => {
        //console.log(params.view)
        //if(prevView !== view) {
            if(selectedView) {
                setDetailsTab(selectedView)
                //console.log(detailsTab)
            }
        //}
    }, [selectedView])

    useEffect(() => {
        if (returnMessage.success) {
            window.location.reload()
        }
    }, [returnMessage.success, returnMessage])

    const deleteLeg = (leg) => {
        postData({}, `/api/portal/delete-leg?dealId=${leg['deal.id']}&damRef=${leg.daM_Ref}&zohoId=${leg.id}`, 1000)
    }


    return (
        <>
            <TitleBar title='Details' cta='Home' url='/portal'/>

            <div className={'portal__deal_details'}>
                <PortalDetailsHeader
                    deal={dealData} 
                />


                {
                <TabBar>
                                
                    <Link to={`/portal/deal-details/sales/${dealId}`}><Tab selected={detailsTab === 'sales'}>S & C</Tab></Link>
                    <Link to={`/portal/deal-details/ops/${dealId}`}><Tab selected={detailsTab === 'ops'}>Ops</Tab></Link>
                    <Link to={`/portal/deal-details/finance/${dealId}`}><Tab selected={detailsTab === 'finance'}>Finance</Tab></Link>
                </TabBar>
                }

                <div className={'portal__details_content'}>
                    {(detailsTab === 'sales') &&
                        <>
                            <PortalSalesDetails 
                                deal={dealData}
                                legs={actualLegData}
                                onDeleteLeg={deleteLeg}
                            />
                        </>
                    }

                    {(detailsTab === 'ops') &&
                        <>
                            <PortalOpsDetails 
                                deal={dealData}
                                legs={actualLegData}
                            />
                        </>
                    }

                    {(detailsTab === 'finance') &&
                        <>
                            <PortalFinanceDetails
                                deal={dealData}
                                legs={actualLegData}
                            />
                        </>
                    }
                </div>
            </div>
        </>
    )


}


export default PortalDealDetails